export const detectEsicReasonIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /* ----------------------------------
     * DELETE REASON
     * ---------------------------------- */
    const deleteRegex =
        /(delete|remove|erase|drop|get rid of)\s+(the\s+)?(reason)?\s*(named|called|for)?\s*(.+)?/;

    const deleteMatch = cleaned.match(deleteRegex);

    if (
        deleteMatch &&
        cleaned.includes("esic") &&
        cleaned.includes("reason")
    ) {
        return {
            intent: "delete_esic_reason",
            name: deleteMatch[5]?.trim() || undefined
        };
    }

    /* ----------------------------------
     * CREATE REASON
     * ---------------------------------- */
    const createRegex =
        /(create|add|make|setup|set up|configure|define)\s+(a\s+|new\s+)?(reason)?\s*(named|called|for)?\s*(.+)?/;

    const createMatch = cleaned.match(createRegex);

    if (
        createMatch &&
        cleaned.includes("esic") &&
        cleaned.includes("reason")
    ) {
        return {
            intent: "create_esic_reason",
            name: createMatch[5]?.trim() || undefined
        };
    }

    return null;
};
